module.exports = __webpack_public_path__ + "static/media/amity_university.db366e3d.png";